import Helpers from "@/services/helpers";

import core from "./modules/core";
import state from "./modules/state";
import track from "./modules/track";
import shuffle from "./modules/shuffle";
import repeat from "./modules/repeat";
import volume from "./modules/volume";
import queue from "./modules/queue";
import playback from "./modules/playback";
import session from "./modules/session";

export default class Player {
  constructor({
    store,
    modules = [
      core,
      state,
      track,
      shuffle,
      repeat,
      volume,
      playback,
      queue,
      session
    ]
  }) {
    this.id = Helpers.getUid();
    this.modules = modules;
    this.store = store;
    this.currentTrack = null;
    this.installModules();
    this.mod.state.restore();
    this.mod.state.listen();
  }
  installModules() {
    this.mod = {};
    this.modules.forEach(mod => {
      this.mod[mod.name] = mod.install(this, this.store);
    });
  }
  stop() {
    if (this.running || this.paused) {
      this.mod.playback.stop();
      this.mod.state.save({ running: false });
    }
  }
  async play({ index, tracklist = {} }) {
    await this.mod.playback.play({ index, tracklist });
    this.mod.state.save({ running: true });
  }
  pause() {
    this.mod.playback.pause();
    this.mod.state.save({ running: false });
  }
  toggle() {
    this.mod.playback.toggle();
  }
  prev() {
    this.mod.playback.prev();
    this.mod.state.save({ running: true });
  }
  next(force) {
    this.mod.playback.next(force);
    this.mod.state.save({ running: true });
  }
  rewind(per, lazy) {
    this.mod.playback.rewind(per, lazy);
  }
  addToQueue(tracks) {
    this.mod.playback.add(tracks);
    this.mod.state.save({ running: true });
  }

  removeFromQueue(track) {
    this.mod.playback.remove(track);
    this.mod.state.save({ running: true });
  }

  clearQueue() {
    this.stop();
    this.playlist = null;
    this.mod.queue.clear();
    this.mod.state.save();
  }
  setVolume(value) {
    this.mod.volume.set(value);
    this.mod.state.save();
  }
  toggleRepeat(target) {
    this.mod.repeat.toggle(target);
    this.mod.state.save();
    this.mod.session.set();
  }
  toggleShuffle() {
    this.mod.shuffle.toggle();
    this.mod.state.save();
    this.mod.session.set();
  }
  get tracklistIds() {
    return this.mod.queue.tracklistIds;
  }
  get currentTrackId() {
    return this.mod.queue.currentTrackId;
  }
  get currentIndex() {
    return this.mod.queue.currentIndex;
  }
  static create({ store, modules }) {
    return new Player({ store, modules });
  }
  static getPlugin() {
    return {
      install(app, { store }) {
        app.prototype.$player = Player.create({ store });
      }
    };
  }
}
